/**
 * O CASO QUE NÃO PODE ACONTECER — e que, sem isto, acontece em silêncio.
 *
 * Um `switch` sobre `interaction.kind` que cobre as onze interações de hoje continua
 * compilando amanhã, quando houver doze: o caso novo simplesmente não entra em nenhum
 * ramo, e a função devolve o que devolveria se não houvesse nada a fazer. Nenhum erro,
 * nenhum teste vermelho — uma interação que não aparece na tela, ou uma prova impressa
 * sem o campo de resposta.
 *
 * Num `default`, `nunca(x)` inverte isso. Enquanto o `switch` for exaustivo, `x` tem
 * tipo `never` e a chamada compila; no dia em que faltar um caso, `x` passa a ter o
 * tipo do caso esquecido e **o compilador recusa o arquivo**, apontando exatamente a
 * linha. O erro em tempo de execução que sobra é só a rede de segurança para dados que
 * vieram de fora do TypeScript — um registro antigo, um JSON de outra versão.
 *
 * Custou três interações para a lição pegar: `balance-ops` exigiu tocar em treze
 * arquivos, e os três `switch` que ficavam calados não estavam entre os que o
 * compilador cobrou.
 */

export function nunca(x: never, onde: string): never {
  const visto = (x as { kind?: unknown } | null)?.kind ?? x;
  throw new Error(`${onde}: caso não tratado — ${String(visto)}`);
}
